var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 68,
    viewBox: "0 0 71 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0330192 58.951C0.0149716 58.4312 0.431441 58 0.951526 58H56.1189C56.5868 58 56.9705 58.3706 56.9867 58.8382C57.1572 63.7489 53.2225 67.8226 48.3088 67.8226H9.21808C4.26638 67.8226 0.20485 63.8997 0.0330192 58.951Z",
    fill: "#81168C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4418 62.6765C45.0327 62.6765 54.7986 50.4823 56.1813 34.0858C56.3709 31.8364 54.5209 30 52.2634 30H5.08745C2.83001 30 0.981042 31.8358 1.14891 34.087C2.37156 50.4829 11.1742 62.6765 29.4418 62.6765Z",
    fill: "#81168C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.185 58.2725L60.4575 50.1749",
    stroke: "white",
    strokeWidth: 0.818552,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0942 58.2288L56.3667 50.1312",
    stroke: "white",
    strokeWidth: 0.818552,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0004 58.1851L52.2729 50.0875",
    stroke: "white",
    strokeWidth: 0.818552,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6988 50.9316C9.19278 54.6416 12.3672 57.4801 16.1856 57.4801H55.2764C59.0132 57.4801 62.0523 54.5766 62.3054 50.9316H8.6988ZM7.91907 49.2945C7.39899 49.2945 6.98252 49.7257 7.00057 50.2455C7.1724 55.1942 11.2339 59.1172 16.1856 59.1172H55.2764C60.19 59.1172 64.1248 55.0434 63.9543 50.1327C63.938 49.6652 63.5543 49.2945 63.0865 49.2945H7.91907Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8743 44.1941C58.152 39.4149 60.8363 32.628 61.5044 24.7044C61.6058 23.5015 60.6112 22.3932 59.2179 22.3932H12.0419C10.6533 22.3932 9.64493 23.5008 9.73594 24.7213C10.0965 29.5561 11.1317 33.9481 12.8573 37.7156C12.4859 38.2287 12.1441 38.7841 11.8385 39.3763C9.72826 35.1764 8.50561 30.2372 8.10337 24.8431C7.9355 22.5919 9.78447 20.7561 12.0419 20.7561H59.2179C61.4753 20.7561 63.3254 22.5925 63.1357 24.8419C62.1257 36.8194 56.6423 46.5544 47.6826 50.9318H43.0559C47.3703 49.7512 50.998 47.4075 53.8743 44.1941ZM23.01 50.6317C23.2215 50.7344 23.4354 50.8344 23.6517 50.9318H28.7065C26.9826 50.5131 25.3901 49.9488 23.9233 49.2539C23.6426 49.7426 23.3368 50.203 23.01 50.6317Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2852 24.924C64.3289 24.7017 69.4042 25.7909 69.9492 31.2592C70.6304 38.0946 64.2872 43.6406 55.2607 43.974",
    stroke: "white",
    strokeWidth: 1.6371
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9875 15.817V15.817C26.6337 14.9939 27.2178 12.9349 26.249 11.37L25.5449 10.2325C24.4342 8.43841 24.7708 6.10601 26.3433 4.69902L26.8609 4.2359",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5036 12.5811V12.5811C35.1498 11.758 35.7339 9.69902 34.7651 8.13409L34.061 6.99664C32.9504 5.20252 33.2869 2.87011 34.8594 1.46312L35.377 1",
    stroke: "white",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0212 15.9873V15.9873C43.6674 15.1642 44.2515 13.1052 43.2827 11.5403L42.5786 10.4028C41.4679 8.60871 41.8045 6.27631 43.377 4.86932L43.8946 4.4062",
    stroke: "white",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5112 28.0794H29.7563",
    stroke: "white",
    strokeWidth: 0.818552,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.998 28.0794L60.9918 28.0123",
    stroke: "white",
    strokeWidth: 0.818552,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.022 31.6559H24.9874",
    stroke: "white",
    strokeWidth: 0.818552,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.2064,
    cy: 28.2497,
    r: 1.02186,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0085 49.4715C23.5361 48.554 23.9683 47.515 24.2663 46.3771C24.9557 43.7439 24.7635 41.2014 23.9712 39.2381C23.1792 37.2754 21.8413 35.987 20.2474 35.55C18.6536 35.1129 16.8655 35.5441 15.2207 36.8386C13.5753 38.1334 12.1666 40.237 11.4772 42.8701C10.8349 45.3231 10.9578 47.6973 11.6181 49.5979C11.0631 49.8939 10.6343 50.3835 10.4097 50.9642C9.34502 48.5856 9.08853 45.5301 9.89834 42.4372C11.4394 36.5513 16.2585 32.7587 20.6621 33.9662C25.0657 35.1738 27.3862 40.9241 25.8451 46.81C25.4941 48.1508 24.973 49.3828 24.3254 50.472C23.9979 50.021 23.5411 49.669 23.0085 49.4715Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0645 37.044C22.2765 36.9656 22.3849 36.7302 22.3065 36.5182C22.2282 36.3062 21.9928 36.1978 21.7808 36.2762C18.6022 37.4508 17.0952 39.3768 16.5251 41.4537C15.9636 43.4993 16.327 45.6335 16.759 47.2249C16.9639 47.98 16.9701 48.8525 16.8563 49.732H17.6812C17.7913 48.8088 17.7803 47.8628 17.5489 47.0104C17.1293 45.4646 16.8115 43.5029 17.3144 41.6704C17.8088 39.8693 19.1119 38.1351 22.0645 37.044Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon_2.8a6784dd93dfc2404672cf09d6b5a96d.svg";
export { ForwardRef as ReactComponent };